import { render, staticRenderFns } from "./ReportFileProperties.vue?vue&type=template&id=64edda6a&"
import script from "./ReportFileProperties.vue?vue&type=script&lang=js&"
export * from "./ReportFileProperties.vue?vue&type=script&lang=js&"
import style0 from "./ReportFileProperties.vue?vue&type=style&index=0&id=64edda6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports